import React, {useState, useContext} from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import request from "../../services/request";
import LoadingButton from '@mui/lab/LoadingButton';
import {AlertContext} from "../base/AlertBox";
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import BraftEditor from 'braft-editor'
import 'braft-editor/dist/index.css'
import '../../css/rich-text-editor.css'
import LocalStorageUtils from "../../utils/localStorageUtils";
import RoundsGroup from "./RoundsGroup";
import RichTextEditor from "./RichTextEditor";

export default function AddTextForm({refresh}) {
    //标题
    const [title, setTitle] = useState('');
    //轮次
    const [rounds, setRounds] = useState([])
    //按钮状态
    const [loading, setLoading] = useState(false);
    //提示框
    const {alertOpen} = useContext(AlertContext)
    //编辑状态
    const [editorState, setEditorState] = useState(BraftEditor.createEditorState(''));//<p><strong>标题</strong></p><hr/><p></p>

    //提交
    const handleSubmit = (event) => {
        event.preventDefault();
        if(title === ''){
            alertOpen('warning', '请输入标题！')
            return;
        }
        if(rounds.length === 0){
            alertOpen('warning', '请选择复习轮次！')
            return;
        }
        setLoading(true)
        request({
            url: '/review/add/text',
            method: 'post',
            data: JSON.stringify({
                name: title,
                content: JSON.parse(LocalStorageUtils.getInstance().getItem("editorContent")),
                rounds: rounds
            })
        }).then(response => {
            if(response.code === 200){
                alertOpen('success', '添加成功！')
                setTitle('')
                setEditorState(BraftEditor.createEditorState(''))
                refresh && refresh();
            }else {
                alertOpen('error', response.msg)
            }
            setLoading(false);
        })
    };



    return (
        <Container component="main" sx={{backgroundColor: '#ffffff'}}>
            <Box component="form"  onSubmit={handleSubmit} noValidate >
                <TextField
                    margin="normal"
                    fullWidth
                    id="title"
                    name="title"
                    label="复习标题"
                    autoComplete="title"
                    value={title}
                    onChange={(event) => setTitle(event.target.value)}
                />
                {/*富文本编辑器*/}
                <RichTextEditor value={{editorState, setEditorState}} previewTitle={title}/>
                <Divider />
                {/*轮次选择*/}
                <RoundsGroup rounds={{rounds, setRounds}}/>

                <Box sx={{margin: '0 70px'}}>
                    <LoadingButton
                        type="submit"
                        fullWidth
                        variant="contained"
                        loading={loading}
                        sx={{ mt: 3, mb: 2}}
                    >
                        添加复习内容
                    </LoadingButton>
                </Box>
            </Box>
        </Container>
    );
}